import styled from "styled-components";

/* ── Parcel result card ──────────────────────────── */

export const ParcelCard = styled.div`
  background: var(--surface);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-left: 3px solid var(--primary);
  border-radius: var(--border-radius);
  padding: 0.875rem 1rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: box-shadow 0.15s ease, transform 0.15s ease;

  &:hover {
    box-shadow: var(--shadow);
    transform: translateY(-1px);
  }

  body.dark & {
    background: var(--surface-2);
    border-color: rgba(255, 255, 255, 0.07);
  }
`;

export const ParcelGrid = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.25rem 1.25rem;

  @media (max-width: 767.98px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5rem 1rem;
  }
`;

export const ParcelMeta = styled.div``;

export const ParcelMetaLabel = styled.p`
  font-size: 0.625rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text-label);
  margin: 0 0 0.125rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

export const ParcelMetaValue = styled.p`
  font-size: 0.9375rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0;
  white-space: nowrap;

  &.primary {
    color: var(--primary);
    font-size: 1.0625rem;
  }

  &.muted {
    color: var(--text-muted);
    font-size: 0.8125rem;
    font-weight: 500;
  }
`;

export const CompensationPill = styled.span`
  display: inline-block;
  background: var(--surface-2);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: var(--border-radius-sm);
  padding: 0.125rem 0.5rem;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--text-primary);
`;

export const ParcelAction = styled.div`
  flex-shrink: 0;

  a, button {
    white-space: nowrap;
  }
`;

/* ── Results section ─────────────────────────────── */

export const ResultsHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  gap: 0.5rem;

  h5 {
    flex: 1;
    margin: 0;
    font-size: 0.875rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: var(--text-muted);
    text-align: center;
  }
`;

export const ResultsScroll = styled.div`
  max-height: 68vh;
  overflow-y: auto;
  padding: 0.25rem 0.25rem 0.5rem;

  /* scrollbar */
  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-track { background: transparent; }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 2px;
  }
`;

export const Disclaimer = styled.div`
  background: rgba(0, 0, 0, 0.025);
  border-radius: var(--border-radius-sm);
  padding: 0.75rem 1rem;
  margin-top: 0.75rem;

  p {
    font-size: 0.75rem;
    color: var(--text-muted);
    margin: 0;
    line-height: 1.5;
  }

  body.dark & { background: rgba(255, 255, 255, 0.04); }
`;

/* ── Value field wrapper ─────────────────────────── */

export const ValueRow = styled.div`
  display: flex;
  align-items: stretch;
  border: 1px solid var(--border);
  border-radius: 0.375rem;
  overflow: hidden;
  background: var(--surface);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus-within {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px rgba(var(--primary-rgb), 0.12);
  }

  &.has-error { border-color: var(--danger); }
`;

export const ValuePrefix = styled.span`
  padding: 0 0.75rem;
  background: var(--surface-2);
  border-right: 1px solid var(--border);
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-muted);
  white-space: nowrap;
`;

export const ValueInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  padding: 0.625rem 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  background: transparent;

  &::placeholder { color: var(--text-label); font-weight: 400; }
`;
